export default __webpack_public_path__ + "static/media/bar-statistic-report.d8154780.svg";